/*
    Functions to use with the _color_picker.html.erb partial
    id is the same id as specified for the color_picker
 */

// --------------------------- Exported functions ---------------------------

// Check for all possible color warnings (black, white, background)
function updateAllColorWarnings(id, backgroundTextField=null){
    updateBlackWarning(id)
    updateWhiteWarning(id)
    updateBackgroundWarning(id, backgroundTextField) // changes nothing if backgroundTextField is null
}

// Checks the color of the Text field against black and shows the warnings if they exist
function updateBlackWarning(id){
    let colorValue = document.getElementById(`${id}TextField`)?.value
    let blackWarning = document.getElementById(`${id}BlackWarning`)
    if (colorValue && blackWarning) {
        if (!colorPassesBlack(colorValue)) {
            blackWarning.classList.remove('hidden')
        } else {
            blackWarning.classList.add('hidden')
        }
    }
}

// Checks the color of the Text field against white and shows the warnings if they exist
function updateWhiteWarning(id){
    let colorValue = document.getElementById(`${id}TextField`)?.value
    let whiteWarning = document.getElementById(`${id}WhiteWarning`)
    if (colorValue && whiteWarning) {
        if (!colorPassesWhite(colorValue)) {
            whiteWarning.classList.remove('hidden')
        } else {
            whiteWarning.classList.add('hidden')
        }
    }
}

// Checks the color of the Text field against the background and shows the warnings if they exist
function updateBackgroundWarning(id, backgroundTextField){
    let colorValue = document.getElementById(`${id}TextField`)?.value
    let backgroundWarning = document.getElementById(`${id}BackgroundWarning`)
    let backgroundValue = backgroundTextField === null || backgroundTextField.disabled ? null : backgroundTextField.value
    // Skip the check if backgroundValue or a necessary Element not exists
    if (colorValue && backgroundWarning) {
        if (backgroundValue === null){
            backgroundWarning.classList.add('hidden')
        } else if (!colorCombinationPasses(colorValue, backgroundValue)) {
            backgroundWarning.classList.remove('hidden')
        } else {
            backgroundWarning.classList.add('hidden')
        }
    }
}

// Hide all color warnings for a given id
function hideColorWarnings(id){
    document.getElementById(`${id}BlackWarning`)?.classList?.add('hidden')
    document.getElementById(`${id}WhiteWarning`)?.classList?.add('hidden')
    document.getElementById(`${id}BackgroundWarning`)?.classList?.add('hidden')
}

// --------------------------- Exported functions END ---------------------------

// Calculates the contrast ratio as specified in WCAG of two colors
function colorCombinationPasses(hex1, hex2, threshold=2.0){
    let rgb1 = hexToRgb(hex1)
    let l1 = luminance(rgb1)
    let rgb2 = hexToRgb(hex2)
    let l2 = luminance(rgb2)

    return contrastRatio(l1, l2) > threshold
}

// Calculates the contrast ratio as specified in WCAG against black
function colorPassesBlack(hex, threshold=2.0){
    let rgb = hexToRgb(hex)
    let l = luminance(rgb)

    return contrastRatio(l, 0.0) > threshold   // luminance vs black
}

// Calculates the contrast ratio as specified in WCAG against white
function colorPassesWhite(hex, threshold=2.0){
    let rgb = hexToRgb(hex)
    let l = luminance(rgb)

    return contrastRatio(l, 1.0) > threshold // luminance vs white
}

//--------------------------------------------
// Helper functions to calculate contrast ratio

// Calculates the normalized rgb values from a 6-digit hex-code
function hexToRgb(hex) {
    let h = hex.trim()
    if (h[0] === '#'){
        h = h.slice(1)
    }
    let r, g, b
    r = parseInt(h.slice(0,2), 16) / 255
    g = parseInt(h.slice(2,4), 16) / 255
    b = parseInt(h.slice(4,6), 16) / 255
    return [r, g, b]
}

// calculates the linear luminance of a color channel
function srgbChannelToLinear(c) {
    // c in [0..1](gamma - korrigiert)->linear
    if (c <= 0.03928) {
        return c / 12.92
    } else {
        return Math.pow((c + 0.055) / 1.055,  2.4)
    }
}

// Calculates the luminance of a given color
// rgb is an array [r,g,b] with values between 0 and 1
function luminance(rgb) {
    let [r_lin, g_lin, b_lin] = rgb.map(srgbChannelToLinear)
    // relative luminance (sRGB, WCAG)
    return 0.2126 * r_lin + 0.7152 * g_lin + 0.0722 * b_lin
}

// Calculates the contrast ratio as specified in WCAG
function contrastRatio(l1, l2){
    let lighter = Math.max(l1, l2)
    let darker = Math.min(l1, l2)
    return (lighter + 0.05) / (darker + 0.05)
}

export {updateAllColorWarnings, updateBlackWarning, updateWhiteWarning, updateBackgroundWarning, hideColorWarnings}